import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const ProtectedRoutes = () => {
  const token = cookies.get("TOKEN");

  // Permitir el acceso a cualquier usuario autenticado (admin o no)
  return token ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
